// Ссылка на Mini App в Telegram (открывает приложение напрямую)
// Формат: https://t.me/<bot_username>/<app_name> или https://t.me/<bot_username>?startapp=<domain>
// Если Mini App настроен в BotFather, используйте формат /app
// Иначе используйте формат с доменом: ?startapp=https://sntea.online
export const TELEGRAM_MINI_APP_URL = import.meta.env.VITE_TELEGRAM_MINI_APP_URL ?? 'https://t.me/ShennongTea_bot/app';
// Старая переменная для обратной совместимости (если нужно)
export const TELEGRAM_BOT_URL = import.meta.env.VITE_TELEGRAM_BOT_URL ?? TELEGRAM_MINI_APP_URL;

export const MARKETPLACES = [
  { name: 'Ozon', url: 'https://ozon.ru/t/1EWjMdx', icon: '🛒' },
  { name: 'Wildberries', url: 'https://www.wildberries.ru/seller/187652', icon: '📦' },
  { name: 'Яндекс Маркет', url: 'https://market.yandex.ru/cc/8jqc9R', icon: '📦' },
] as const;
